import React from 'react';

const Section = ({
  children,
  className = '',
  background = '',
  maxWidth = 'tw-max-w-7xl',
  padding = 'tw-py-16 md:tw-py-24',
  id,
}) => {
  return (
    <section id={id} className={`${padding} ${background} ${className}`}>
      <div className={`${maxWidth} tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8`}>
        {children}
      </div>
    </section>
  );
};

export default Section;
